module.exports = __webpack_public_path__ + "img/b-icon_catalogs.e35b2b13.svg";